<div class="app-header">
    <app-header></app-header>
</div>
<div class="app-body">
    <router-outlet />
    <app-modal></app-modal>
</div>
<div class="app-footer">
    <app-footer></app-footer>
</div>